import './core-hop';

import {scrollWindowToTarget} from './services/scrollWindowToTarget';
import {mixin} from './services/mixin';
import {extend} from './services/extend';

Object.assign(window.Hop, {
    mixin,
    extend,
    scrollToTarget: scrollWindowToTarget,
});
